import { useCallback, useEffect } from 'react';

import DeleteModal from '@components/delete-modal';
import WarningMessage from '@components/messages/warning-message';
import { useModal } from '@components/modal';

import { useDeleteVersionVulnerabilityAnnotationMutation } from '../../applications.api';

const MODAL_ID = 'vulnerabilityAnnotationDelete';

export const VulnerabilityAnnotationDeleteModal = () => {
  const [deleteAnnotation, { error, isLoading, reset }] =
    useDeleteVersionVulnerabilityAnnotationMutation();

  const { data, id, isOpen } = useModal(MODAL_ID);

  useEffect(() => {
    if (!isOpen) reset();
  }, [isOpen, reset]);

  const handleConfirm = useCallback(async () => {
    if (!data) return false;

    const result = await deleteAnnotation({
      annotationId: data.annotationId,
      appId: data.appId,
      versionId: data.versionId,
      vulnerabilityId: data.vulnerabilityId,
    });

    return !result.error;
  }, [data, deleteAnnotation]);

  return (
    <DeleteModal
      error={error}
      id={id}
      isExecuting={isLoading}
      item="vulnerability annotation"
      onConfirm={handleConfirm}
      successMessage="The vulnerability annotation has been successfully deleted."
      textHeader="Are you sure you want to delete this vulnerability annotation?"
    >
      <WarningMessage level="critical">
        Once it&apos;s deleted, this vulnerability annotation cannot be
        recovered.
      </WarningMessage>
    </DeleteModal>
  );
};

export default VulnerabilityAnnotationDeleteModal;
